<template>
    <div :class="isMobile?'mobileBox':'achievementBox'">
        <p class="font20 fontw">典型业绩</p>
        <div class="tabT" v-if="showTabs && categoryList.length > 0">
            <button :class="activeTab===0?'active':'moren'" @click="changeTab(0, allIds)">全部</button>
            <button :class="activeTab===index+1?'active':'moren'" v-for="(item,index) in categoryList" :key="index" @click="changeTab(index+1,item.id)">{{item.title}}</button>
        </div>
        <div class="achievementShow" v-if="achievementList.length > 0">
            <div :class="isMobile?'achievementMobile':'achievementItem'" v-for="(item,index) in displayList" :key="index" @click="viewDetail(item.id)">
                <img :src="item.picture" alt="">
                <p class="overh2">{{item.title}}</p>
            </div>
        </div>
        <div class="" v-if="achievementList.length==0" style="text-align:center">
            <el-empty description="暂无数据"></el-empty>
        </div>
        <el-pagination
            v-if="showPagination && achievementList.length > pageSize"
            class="pageBox"
            background
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :layout="isMobile?'prev, pager, next':'prev, pager, next, jumper'"
            :pager-count="isMobile?'5':'7'"
            :page-size="pageSize"
            :total="achievementList.length">
        </el-pagination>
    </div>
</template>

<script>
export default {
    name: 'TypicalAchievement',
    props: {
        // 业务类型ID，用于过滤典型业绩
        businessType: {
            type: String,
            default: ''
        },
        // 是否显示分类标签
        showTabs: {
            type: Boolean,
            default: true
        },
        // 是否显示分页
        showPagination: {
            type: Boolean,
            default: true
        },
        // 每页显示数量
        pageSize: {
            type: Number,
            default: 6
        },
        // 最大显示数量（不分页时使用）
        maxCount: {
            type: Number,
            default: 6
        }
    },
    data() {
        return {
            isMobile: false,
            activeTab: 0,
            categoryList: [],
            achievementList: [],
            allIds: '',
            currentTabId: '',
            currentPage: 1
        }
    },
    computed: {
        displayList() {
            if (this.showPagination) {
                const start = (this.currentPage - 1) * this.pageSize;
                const end = start + this.pageSize;
                return this.achievementList.slice(start, end);
            } else {
                return this.achievementList.slice(0, this.maxCount);
            }
        }
    },
    mounted() {
        this.checkMobile();
        window.addEventListener('resize', this.checkMobile);
        this.getCategories();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkMobile);
    },
    methods: {
        checkMobile() {
            this.isMobile = window.innerWidth <= 768;
        },
        // 切换分类
        changeTab(index, id) {
            this.activeTab = index;
            this.currentPage = 1;
            if (index === 0) {
                this.currentTabId = this.allIds;
            } else {
                this.currentTabId = id;
            }
            this.getAchievements();
        },
        // 获取分类列表
        getCategories() {
            this.Request({
                url: '/webindex/zjrh/typicalAchievementCata',
                method: 'get',
            }).then((data) => {
                if (data.tdata && data.tdata.length > 0) {
                    // 如果有业务类型，过滤对应的分类
                    if (this.businessType) {
                        const filteredCategories = data.tdata.filter(item =>
                            item.title.includes(this.businessType)
                        );

                        if (filteredCategories.length > 0) {
                            const filteredIds = filteredCategories.map(item => item.id);
                            this.allIds = filteredIds.toString();
                            this.currentTabId = this.allIds;
                            this.categoryList = filteredCategories;
                        } else {
                            // 如果没有找到匹配的分类，使用所有分类
                            const arr = [];
                            data.tdata.forEach(item => {
                                arr.push(item.id);
                            });
                            this.allIds = arr.toString();
                            this.currentTabId = this.allIds;
                            this.categoryList = data.tdata;
                        }
                    } else {
                        // 没有业务类型，使用所有分类
                        const arr = [];
                        data.tdata.forEach(item => {
                            arr.push(item.id);
                        });
                        this.allIds = arr.toString();
                        this.currentTabId = this.allIds;
                        this.categoryList = data.tdata;
                    }

                    this.getAchievements();
                }
            });
        },
        // 获取典型业绩列表
        getAchievements() {
            const categoryId = this.currentTabId;

            this.Request({
                url: '/webindex/zjrh/typicalAchievement',
                method: 'get',
                data: {
                    id: categoryId,
                    pageindex: 1,
                    pagesize: 100 // 获取所有数据，前端分页
                }
            }).then((data) => {
                if (data.rows && data.rows.length > 0) {
                    this.achievementList = data.rows;
                } else {
                    this.achievementList = [];
                }
            });
        },
        handleCurrentChange(val) {
            this.currentPage = val;
        },
        // 查看详情
        viewDetail(id) {
            window.location.assign('/aboutUs/SocialValueInfo?id=' + id);
        }
    }
}
</script>

<style scoped lang="less">
.achievementBox {
    width: 1200px;
    margin: 0 auto;
    margin-top: 60px;
    padding-bottom: 50px;
}

.mobileBox {
    width: 100%;
    padding: 0 10px;
    margin-top: 30px;
    padding-bottom: 30px;
}

.tabT {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-top: 30px;
}

.active {
    padding: 10px 15px;
    color: #fff;
    background-color: #247CD6;
    border-radius: 5px;
    border: none;
    margin-right: 16px;
    margin-bottom: 15px;
    cursor: pointer;
}

.moren {
    padding: 10px 15px;
    color: #333;
    background-color: #F4F4F4;
    border-radius: 5px;
    border: none;
    margin-right: 16px;
    margin-bottom: 15px;
    cursor: pointer;
}

.tabT .moren:hover {
    color: #247CD6;
}

.achievementShow {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    margin-top: 28px;
}

.achievementItem {
    width: 388px;
    margin-right: 18px;
    margin-bottom: 32px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s;
}

.achievementItem:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

.achievementItem img {
    width: 388px;
    height: 240px;
    margin-bottom: 20px;
    object-fit: cover;
    border-radius: 8px;
}

.achievementItem:nth-child(3n) {
    margin-right: 0;
}

.achievementMobile {
    width: 49%;
    margin-right: 2%;
    text-align: center;
    margin-bottom: 20px;
    cursor: pointer;
}

.achievementMobile:nth-child(2n) {
    margin-right: 0;
}

.achievementMobile img {
    width: 100%;
    height: 120px;
    margin-bottom: 10px;
    object-fit: cover;
    border-radius: 6px;
}

.overh2 {
    font-size: 16px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 10px;
}

.achievementItem:hover p,
.achievementMobile:hover p {
    color: #247CD6;
}

.pageBox {
    text-align: center;
    margin-top: 35px;
    margin-bottom: 42px;
}

.font20 {
    font-size: 36px;
    font-weight: bold;
    color: #333333;
}

.fontw {
    font-weight: bold;
}

@media screen and (max-width: 768px) {
    .font20 {
        font-size: 24px;
    }
}
</style>
